import { render, staticRenderFns } from "./StageGames.vue?vue&type=template&id=d959cd4c&scoped=true&"
import script from "./StageGames.vue?vue&type=script&lang=js&"
export * from "./StageGames.vue?vue&type=script&lang=js&"
import style0 from "./StageGames.vue?vue&type=style&index=0&id=d959cd4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d959cd4c",
  null
  
)

export default component.exports